<template>
    <div>
        <div style="min-height: 70vh;">
            <router-view></router-view>
        </div>

        <footer class="p-10 bottom-0  w-full">
            <p class="lato text-base text-center text-gray-800">Tecnologia SaveLeads - WDC</p>
        </footer>
    </div>
</template>

<script>

    import moduleIntegracao from "../../store/integracao/moduleIntegracao";

    // Base css
    import "@/assets/css/style.css";
    import "@/assets/css/responsive.css";

    export default {
        name: "Main",
        created() {
            if (!moduleIntegracao.isRegistered) {
                this.$store.registerModule("integracao", moduleIntegracao);
                moduleIntegracao.isRegistered = true;
            }
        },
        computed: {
            currentStep() {
                return this.$store.state.integracao.step;
            },
        },
        data() {
            return {
                paginaAtual: 1,

                user: 'Ana',
                paginas: [

                    {
                        tipo: 'texto',
                        conteudo: {
                            titulo: 'Titulo',
                            banner: 'header-bg.png',
                            texto: `

                <p>Sabemos exatamente a sensação de estar em um ambiente totalmente novo e muitas vezes envolto de pressão. Relaxa, aqui todo mundo é como você, humano e com seus receios, mas estamos sempre abertos pra te receber. Queremos te deixar o mais confortável possível, por isso vamos explicar um pouco de como será o seu primeiro dia na WDC, para você se preparar.</p>
                <h2>Recepção</h2>
                <p>A Gestão de Talentos irá te recepcionar, indicando onde você poderá guardar seus pertences.</p>
                <h2>Tour</h2>
                <p>Posteriormente, você será levado ao um tour pelo escritório, passando por todos os setores e conversando com os líderes respectivos, para entender o processo de cada área.</p>
                <h2>Mesa</h2>
                <p>Chegou a hora de conhecer seu local de trabalho. Você também irá receber os acessos necessários e entender como funcionam as ferramentas básicas utilizadas na WDC.</p>
                <h2>Digital</h2>
                <p>Você precisa de independência. Nada de ficar na entrada esperando alguém abrir a porta, né?! Por isso vamos cadastrar sua digital de acesso à WDC e para registro no ponto eletrônico.</p>
                <h2>Almoço</h2>
                <p>Porque não almoçar com a gente? Podemos te indicar os melhores locais de te conhecer um pouquinho melhor. Topa?</p>
              `
                            ,

                        },

                    },
                    //Novo
                    {
                        tipo: 'texto',

                        conteudo: {
                            titulo: 'Titulo 7',
                            banner: 'header-bg.png',
                            texto: `
            
                <p>Sabemos exatamente a sensação de estar em um ambiente totalmente novo e muitas vezes envolto de pressão. Relaxa, aqui todo mundo é como você, humano e com seus receios, mas estamos sempre abertos pra te receber. Queremos te deixar o mais confortável possível, por isso vamos explicar um pouco de como será o seu primeiro dia na WDC, para você se preparar.</p>
                <h2>Recepção</h2>
                <p>A Gestão de Talentos irá te recepcionar, indicando onde você poderá guardar seus pertences.</p>
                <h2>Tour</h2>
                <p>Posteriormente, você será levado ao</p>
            
            `,

                        },

                    },
                    //Novo
                    {
                        tipo: 'texto',
                        conteudo: {
                            titulo: 'Titulo 8',
                            banner: 'header-bg.png',
                            texto: `
              
                <h2>Mesa</h2>
                <p>Chegou a hora de conhecer seu local de trabalho. Você também irá receber os acessos necessários e entender como funcionam as ferramentas básicas utilizadas na WDC.</p>
                <h2>Digital</h2>
                <p>Você precisa de independência. Nada de ficar na entrada esperando alguém abrir a porta, né?! Por isso vamos cadastrar sua digital de acesso à WDC e para registro no ponto eletrônico.</p>
                <h2>Almoço</h2>
                <p>Porque não almoçar com a gente? Podemos te indicar os melhores locais de te conhecer um pouquinho melhor. Topa?</p>
              
              `,

                        },

                    }
                ]
            }
        }
    };
</script>

<style>
    @import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@600;900&family=Roboto:wght@300;400;900&display=swap");
</style>
